/**
 * Component template.
 * 
 * Note that this file has a `.tsx` suffix, as it contains React elements.
 */

import * as React from 'react'
import { OwnProps, Props, Actions } from '../containers/CopyFromProject'
import * as ff from 'modules/forms/index'
import * as dt from 'modules/database/types'
import { getAuth } from 'firebase/auth'
import { projectsCollection } from 'modules/database/firebase'
import { getDocs, limit, orderBy, query } from 'firebase/firestore'
import { projectByIdOrUndefined } from 'modules/database/selectors'
import { projectTitle } from 'modules/database/functions'

/**
 * Interface for private internal component state.
 */
interface State {
	selectedValue: string
	projects?: dt.Project[]
}

/**
 * The initial state for our internal component state.
 */
const INITIAL_STATE: State = {
	selectedValue: '',
}

interface MyOwnProps {
	copyButtonLabel?: string
	onCopy: (project: dt.ProjectWithProducts) => void
	onCancel: () => void
}

export default class CopyFromProject extends React.Component<OwnProps & Props & Actions & MyOwnProps, State> {

	public state = INITIAL_STATE

	public componentDidMount(): void {
		this.loadProjects()
	}

	public render() {
		const sortedProjects = this.state.projects ?? []
		return (
			<div className="copy-form">
				<ff.Heading>Copy from</ff.Heading>
				<div className="form-input -select">
					<select className="select" onChange={this.onSelectChange} value={this.state.selectedValue}>
						<option />
						{sortedProjects.map((p, index) => (
							<option key={index} value={p.projectId}>{projectTitle(p)}</option>
						))}
					</select>
				</div>
				<div className="button-group">
					<button type="button" onClick={this.onCopy} disabled={!this.state.selectedValue} className="button-link -secondary -small">{this.props.copyButtonLabel || 'Copy'}</button>
					<button type="button" onClick={this.onCancel} className="button-link -small -text">Cancel</button>
				</div>
			</div>
		)
	}

	private loadProjects() {
		const user = getAuth().currentUser
		if (user) {
			const ref = projectsCollection(user)
			getDocs(query(ref, orderBy('whenUpdated', 'desc'), limit(100))).then(docs => {
				this.setState({
					projects: docs.docs.map(doc => doc.data()),
				})
			}).catch(reason => {
				console.error('Failed to load projects list for copy from component', reason)
			})
		}
	}

	private onSelectChange = (evt: React.ChangeEvent<HTMLSelectElement>) => {
		const selectedIndex = evt.target.selectedIndex
		const selectedValue = evt.target.options[selectedIndex].value
		this.setState({ selectedValue })
	}

	private onCopy = (evt: React.MouseEvent) => {
		evt.preventDefault()
		const projects = this.state.projects

		if (this.state.selectedValue && projects) {
			const selectedProject = projects.find(p => p.projectId === this.state.selectedValue)
			if (selectedProject) {
				projectByIdOrUndefined(selectedProject.projectId).then(project => {
					if (project) {
						this.props.onCopy(project)
					}
				}).catch(error => {
					console.error(`Failed to load selected project: ${selectedProject.projectId}`, error)
				})
			}
		}
	}

	private onCancel = (evt: React.MouseEvent) => {
		evt.preventDefault()
		this.props.onCancel()
	}

}
